import React from 'react';

import { useSnackbar } from 'notistack';
import * as api from 'src/utils/api';
import { TaskWithDetailedTriggeredAction } from 'src/types';
import TriggeredAutomationModal from 'src/views/shared/TaskHandlerModal/TriggeredAutomationModal';
import { useHistory, useLocation } from 'react-router';
import FormRenderer from '../Perspectives/Renderers/FormRenderer';

interface Props {
  onClose: () => void,
  onSuccess: () => void,
  engagementId: string,
  task: TaskWithDetailedTriggeredAction,
}

function TaskHandlerModal({
  onClose,
  onSuccess: _onSuccess,
  engagementId,
  task,
}: Props) {
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const { pathname } = useLocation();

  const refreshCurrentRoute = () => {
    // dirty hack to refresh the whole page when a task is completed
    // we might be updating the current step in the process, data, or role assignments
    const currentRoute = pathname;
    history.push('/');
    history.push(currentRoute);
  };

  const onSuccess = (successMessage?: any) => {
    if (_onSuccess) _onSuccess();
    onClose();

    if (successMessage) {
      enqueueSnackbar(successMessage, {
        variant: 'success'
      });
    }

    refreshCurrentRoute();
  };

  const onDismiss = () => {
    api.dismissTask(engagementId, task.id).then(() => {
      onSuccess('Task dismissed.');
    });
  };

  if (task.triggeredAction) {
    return (
      <TriggeredAutomationModal
        task={task}
        onSuccess={onSuccess}
        onDismiss={onDismiss}
        engagementId={engagementId}
        onClose={onClose}
      />
    );
  }

  return (
    <FormRenderer
      formPerspectiveId={task.taskTemplate.perspectiveId}
      workflowId={task.taskTemplate.workflowId}
      engagementId={task.engagementId}
      resourceType="TASKS" // todo - do I need this
      title={task.taskTemplate.title}
      taskId={task.id}
      closeModal={onClose}
      onSuccess={onSuccess}
    />
  );
}

export default TaskHandlerModal;
